/**
 * Funkcija za postavljanje ikone Clustera.
 *
 * Kako MarkerClusterer nema ugrađenih optimalnih rješenja (opcija) koje bih mogli iskoristiti za promjenu ikone,
 * ovo radimo na način da direktno pristupamo "clusterIcon_" property-u unutar Cluster objekta.
 *
 * @see https://github.com/googlemaps/v3-utility-library/issues/284#issuecomment-392457636
 *
 * @param {object} cluster Cluster
 * @param {string} iconURL URL do ikone Clustera
 */
export default function setClusterIcon(cluster, iconURL) {
    const clusterIconObject = cluster.clusterIcon_; // eslint-disable-line no-underscore-dangle

    if (typeof clusterIconObject === 'undefined' || clusterIconObject === null) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('clusterIcon_ property je null ili nije definiran'); // eslint-disable-line no-console
        }

        return;
    }

    if (!Object.prototype.hasOwnProperty.call(clusterIconObject, 'div_')) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('ClusterIcon objekt nema definiran property div_'); // eslint-disable-line no-console
        }

        return;
    }

    const clusterImageElement = clusterIconObject.div_.querySelector('img'); // eslint-disable-line no-underscore-dangle

    if (clusterImageElement === null) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('Image element ne postoji unutar cluster icon containera'); // eslint-disable-line no-console
        }

        return;
    }

    clusterImageElement.src = iconURL;
}
